import React from 'react'

import { RfShell } from '../components/RfShell'
import { receivingContext, ReceivingFlowController } from '../flow'
import { MenuButton, PreprocessChoiceList, TaskHeader } from '../styles'

interface FreightPalletizationScreenProps {
  controller: ReceivingFlowController
  embedded?: boolean
  onExit: () => void
}

export const FreightPalletizationScreen = ({
  controller,
  embedded = false,
  onExit,
}: FreightPalletizationScreenProps) => {
  const { state, dispatch } = controller

  return (
    <RfShell
      title="Receiving"
      phase="Labels"
      embedded={embedded}
      contextSummary={receivingContext(state)}
      onBack={() => dispatch({ type: 'back' })}
      moreActions={[{ label: 'Exit receiving', onSelect: onExit, danger: true }]}
    >
      <TaskHeader>
        <h1>How did the freight arrive?</h1>
      </TaskHeader>
      <PreprocessChoiceList>
        <MenuButton type="button" onClick={() => dispatch({ type: 'set-freight-palletized', palletized: true })}>
          <strong>Palletized</strong>
          <span>Receive full pallets together; build any partial pallet.</span>
        </MenuButton>
        <MenuButton type="button" onClick={() => dispatch({ type: 'set-freight-palletized', palletized: false })}>
          <strong>Cartons</strong>
          <span>Receive cartons and inner packs onto a pallet.</span>
        </MenuButton>
      </PreprocessChoiceList>
    </RfShell>
  )
}
